// extracted by mini-css-extract-plugin
module.exports = {"app":"MobileAppChannelCheckBox_app__sO0zW","link":"MobileAppChannelCheckBox_link__vKVzQ"};